import { IsString } from 'class-validator';

import { CrudItemListRequest } from '../../crud';

export class NomenclatureTypeChildGetListRequest extends CrudItemListRequest {
    @IsString()
    public nomTypeUuidParent: string;

    constructor(data?: Partial<NomenclatureTypeChildGetListRequest>) {
        super(data);
        this.nomTypeUuidParent = data && data.nomTypeUuidParent;
    }
}
